import { render, staticRenderFns } from "./DadosUsuario.vue?vue&type=template&id=a62dda82&scoped=true"
import script from "./DadosUsuario.vue?vue&type=script&lang=js"
export * from "./DadosUsuario.vue?vue&type=script&lang=js"
import style0 from "./DadosUsuario.vue?vue&type=style&index=0&id=a62dda82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62dda82",
  null
  
)

export default component.exports